if (!customElements.get('email-popup')) {
  customElements.define('email-popup', class EmailPopup extends HTMLElement {
   constructor() {
    super();

    if (window.location.pathname === "/challenge") {
      return;
    }

    this.popup = this.querySelector(".email__popup--mdoal__content");
    this.closePopup = this.querySelectorAll(".email__popup--toggle, .email-popup-overlay");
    this.hidePopup = this.querySelector('.email__popup--hide');
    this.copyButton = this.querySelector('.vp-code__copy');
    this.cookieName = "email-popup";
    this.subscribedCookieName = "email-popup-subscribed";

    // Modals that render above this popup. Wait for them to be dismissed
    // before opening, otherwise this one opens invisibly behind them.
    this.blockingSelectors = ['#vpd-modal'];

    this.closePopup.forEach((item) => {
      item.addEventListener("click", this.close.bind(this));
    });
    this.hidePopup?.addEventListener("click", this.hide.bind(this));
    this.copyButton?.addEventListener("click", this.copyCode.bind(this));

    // Shopify reloads the page with ?customer_posted=true after the newsletter
    // form is submitted. Reopen straight away so the visitor actually sees the
    // discount code, and never nag a subscriber again.
    this.justSubscribed = window.location.search.indexOf("customer_posted=true") !== -1;

    if (this.justSubscribed) {
      this.setCookie(this.subscribedCookieName, 365);
      if (!(window.Shopify && Shopify.designMode)) {
        this.openWhenClear();
      }
    } else if (this.shouldShow()) {
      this.init();
    }

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener("shopify:section:load", (event) =>
        editorShopifyEvent(event, this, () => this.open.bind(this))
      );
      document.addEventListener("shopify:section:select", (event) =>
        editorShopifyEvent(event, this, this.open.bind(this))
      );
      document.addEventListener("shopify:section:deselect", (event) =>
        editorShopifyEvent(event, this, this.close.bind(this))
      );
    }

   }

  // Testing mode always shows; otherwise respect both dismissal cookies
  shouldShow() {
    if (this.dataset.mode === "test") return true;
    return !this.getCookie(this.cookieName) && !this.getCookie(this.subscribedCookieName);
  }

   // Init popup
    init() {

      if (window.Shopify && Shopify.designMode) {
        return;
      }

      setTimeout(
        function() {
          this.openWhenClear();
        }.bind(this),
        parseInt(this.dataset.delay) * 1000
      );
    }

  // Is another modal currently covering the page?
  // Do NOT use offsetParent here: these overlays are position:fixed, and fixed
  // elements always report offsetParent as null even when fully visible, which
  // made this return false every time. Measure the rendered box instead.
  blockingModalVisible() {
    return this.blockingSelectors.some((selector) => {
      const el = document.querySelector(selector);
      if (!el) return false;

      const style = window.getComputedStyle(el);
      if (style.display === "none" || style.visibility === "hidden" || style.opacity === "0") {
        return false;
      }

      const rect = el.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    });
  }

  // Poll until nothing is covering the page, then open. Gives up after ~60s
  // so the popup can never hang around waiting forever.
  openWhenClear(attempts) {
    const tries = attempts || 0;

    if (this.blockingModalVisible() && tries < 120) {
      setTimeout(this.openWhenClear.bind(this, tries + 1), 500);
      return;
    }

    this.open();
  }

   // Open popup
  open() {
    document.body.classList.add('email-popup-show');
    this.popup.classList.add('popup-open');
  }

  // Dismiss animation shared by close() and hide()
  dismiss() {
    document.body.classList.remove('email-popup-show');
    this.popup.classList.add('popup-closing');
    setTimeout(() => {
      this.popup.classList.remove('popup-open');
      this.popup.classList.remove('popup-closing');
    }, 500);
  }

  // Close popup. Closing counts as a dismissal, so remember it for the
  // configured number of days instead of reopening on every page load.
  close(){
    this.dismiss();

    if (this.dataset.mode === "test") {
      this.removeCookie(this.cookieName);
      return;
    }

    this.setCookie(this.cookieName, this.dataset.expire);
  }

 // Hide popup for fixed days

  hide() {
    this.dismiss();
    this.setCookie(this.cookieName, this.dataset.expire);
  }

  // Copy the discount code to the clipboard
  copyCode(event) {
    const button = event.currentTarget;
    const code = button.dataset.code;
    if (!code) return;

    const done = () => {
      const label = button.querySelector('.vp-code__copy-label');
      if (!label) return;
      const original = label.textContent;
      label.textContent = 'Copied';
      setTimeout(() => { label.textContent = original; }, 2000);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(() => {});
    }
  }

    getCookie(name) {
      const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
      return match ? match[2] : null;
    }

    setCookie(name, expiry) {
      document.cookie = `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/`;
    }

    removeCookie(name) {
      document.cookie = `${name}=; max-age=0; path=/`;
    }


  });
}
